// extracted by mini-css-extract-plugin
export default {"header":"Header_header__NJf6C","toggleButton":"Header_toggleButton__Awfsf","sun":"Header_sun__xCbMl","moon":"Header_moon__fXYDU"};